var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.customer.vat_validation_status == 'error')?_c('span',{staticClass:"fa fa-exclamation text-warning"}):(_vm.customer.vat_validation_status == 'ok')?_c('span',{staticClass:"fa fa-check text-success"}):_c('span',{staticClass:"fa fa-question"})])
}
var staticRenderFns = []

export { render, staticRenderFns }